


















































import {
  apiCommodityWriteOffCommodityStoreDetail,
  apiEvaluationEvaluateDetail,
} from '@/api'
import { AsyncReturnType } from 'vtils/types'
import { BookCommentComponents } from '../comment/components'
import { BookComponents } from '../components'
import { computed } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent, useApi, useQuery } from '@/hooks'
import { navigateTo } from '@/router'
import { Track } from '@/utils'

export default defineClassComponent(
  {
    components: {
      ...BookComponents,
      ...BookCommentComponents,
    },
  },
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '评价详情',
        }))
      }

      query = useQuery<{
        commentId: string
      }>()

      apiData = useApi(async () => {
        const commentData = await apiEvaluationEvaluateDetail({
          id: this.query.commentId,
        })
        const { longitude, latitude } = await dcb
          .getLocation()
          .catch(() => ({} as AsyncReturnType<typeof dcb['getLocation']>))
        const storeData = await apiCommodityWriteOffCommodityStoreDetail({
          storeId: commentData.storeId!,
          longitude: longitude as any,
          latitude: latitude as any,
        })
        return {
          ...commentData,
          storeData: storeData,
        }
      })

      pageData = computed(() => this.apiData.data)

      handleStoreClick = () => {
        navigateTo('BookIndex', {
          martId: this.pageData.value.storeId,
        })
      }
    },
)
